<div class="right-menu-content">
    <div class="right-menu-item-header">
        {{i18n._.BRAND}}
    </div>
    <div class="right-menu-item-body" [innerHTML]="i18n._.BRAND_TEXT">
    </div>
    <div class="right-menu-item-header">
        {{i18n._.CONCEPT}}
    </div>
    <div class="right-menu-item-body" [innerHTML]="i18n._.CONCEPT_TEXT">
    </div>
    <a href="https://nelleulla.com/ee-en/" target= _blank>
        <img src="../../assets/brands/brand01.png" />
    </a>
</div>